import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import './globalSearch.scss'
const FormLoading = () => {
  return (
    <form>
    <div className='fields-container'>
      <div className='field'>
        <Skeleton height={14} width={100} />
        <Skeleton height={50} />
      </div>

      <div className='field'>
        <Skeleton height={14} width={100} />
        <Skeleton height={50} />
      </div>

      <div className='field'>
        <Skeleton height={14} width={100} />
        <Skeleton height={50} />
      </div>

      <div className='field'>
        <Skeleton height={14} width={100} />
        <Skeleton height={50} />
      </div>

      <div className='field rounded-full overflow-hidden w-full'>
        <Skeleton height={38.5} className='rounded-full' />
      </div>
    </div>
  </form>
  )
}

export default FormLoading